var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.663 5.962 8.287 18.654c-.225.23-.45.346-.787.346-.338 0-.563-.115-.787-.346l-3.376-3.462a1.135 1.135 0 0 1 0-1.615c.45-.462 1.126-.462 1.575 0L7.5 16.23 19.087 4.346c.45-.461 1.125-.461 1.576 0 .45.462.45 1.154 0 1.616"
})));
export default SvgCheck;